var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBreak(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 3C14.5523 3 15 3.44772 15 4V6.25H16.2002C17.1666 6.25011 17.9502 7.03357 17.9502 8V10C17.9502 10.9664 17.1666 11.7499 16.2002 11.75H15C14.912 11.75 14.8284 11.7319 14.75 11.7041C14.4461 12.7247 13.8958 13.6521 13.1406 14.3857L12.9355 14.5762C11.8927 15.4975 10.5742 16.0033 9.21094 16H7.78809L7.50195 15.9922C6.07172 15.9153 4.71468 15.2787 3.69727 14.2002C2.61226 13.0498 2.00189 11.49 2 9.86328V4C2 3.44772 2.44772 3 3 3H14ZM3.5 9.86133L3.50586 10.0967C3.56196 11.2661 4.02525 12.3612 4.78906 13.1709C5.60102 14.0316 6.68269 14.4986 7.79102 14.5H9.21484C10.2656 14.5026 11.2956 14.0867 12.0957 13.3096C12.8871 12.5407 13.3948 11.4724 13.5 10.3057V4.5H3.5V9.86133ZM15 10.25H16.2002C16.3382 10.2499 16.4502 10.138 16.4502 10V8C16.4502 7.86199 16.3382 7.75011 16.2002 7.75H15V10.25Z",
    fill: "#676879"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreak);
export default __webpack_public_path__ + "static/media/break.81101b85.svg";
export { ForwardRef as ReactComponent };